import { useQueries } from "@tanstack/react-query";
import { api } from "jiffy-api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";

export function useMultipleCanvaDesignStatus(jobIds: string[]) {
  const queries = useQueries({
    queries: jobIds.map(jobId => ({
      queryKey: ["canvaDesignStatus", jobId],
      queryFn: () => api.canva.designStatus({ jobId }).then(objNamesToCamelCase),
      enabled: !!jobId,
      refetchInterval: 2000 // Poll every 2 seconds
    }))
  });

  const completedJobs = queries
    .filter(query => query.data?.job?.status === "success" && query.data?.job?.urls?.[0])
    .map(query => ({
      jobId: query.data?.job?.id,
      url: query.data?.job?.urls?.[0]
    }));

  const hasAllCompleted = jobIds.length > 0 && completedJobs.length === jobIds.length;
  const failedJobs = queries.filter(query => query.data?.job?.status === "failed");

  return {
    completedJobs,
    hasAllCompleted,
    failedJobs,
    isLoading: queries.some(q => q.isLoading)
  };
}
